import { LookupItem } from "../models/lookup-item";
import { IVisaType } from "./visa-type";

export class DecisionDetails {
  visaType: IVisaType | null = null;
  whoMadeDecision: LookupItem | null = null;
  decisionDate = '';
  notifiedBy: LookupItem | null = null;
  notifiedDate = '';
  fileLocation: any = null;
  decisionFile: any[] = [];
  whyAppeal = '';
}